import { Checkbox, FormControl, FormControlLabel, TextField, Typography } from '@mui/material';
import NextButton from 'components/@auth/NextButton';
import { object } from 'prop-types';
import React, { useRef } from 'react';
import { PatternFormat } from 'react-number-format';
import { I18n } from 'utils/i18n';
import connector from '../../connector';
import PhonePrefixField from './PhonePrefixField';
import prefixFormat from './prefixFormat';
import useLoginForm from './useLoginForm';

const inputSx = { mb: '10px' };

function LoginForm(props) {
  const pass = useRef();
  const formik = useLoginForm(props);
  const { values, errors, submitCount, handleBlur, handleSubmit, isSubmitting, setFieldValue } =
    formik;
  const hasSubmitted = submitCount > 0;

  const handleSelect = event => {
    const { actions } = props;
    actions.login.form.update({ prefix: event.value });
    setFieldValue('prefix', event.value);
  };

  const handleChange = e => {
    const { actions } = props;
    const value = ['terms', 'keepSessionOpen'].includes(e.target.name)
      ? e.target.checked
      : e.target.value;
    actions.login.form.update({ [e.target.name]: value });
    if (pass.current) {
      pass.current.parentNode?.removeChild(pass.current);
      pass.current = null;
    }
    formik.handleChange(e);
  };

  return (
    <form onSubmit={handleSubmit}>
      <FormControl fullWidth sx={inputSx}>
        <PhonePrefixField
          value={values.prefix}
          error={!!(hasSubmitted && errors.prefix)}
          onChange={handleSelect}
          helperText={hasSubmitted && errors.prefix}
          name="prefix"
        />
      </FormControl>
      <FormControl fullWidth sx={inputSx}>
        <PatternFormat
          error={!!(errors.phone && hasSubmitted)}
          helperText={hasSubmitted && errors.phone}
          customInput={TextField}
          format={prefixFormat(values.prefix)}
          mask="_"
          name="phone"
          placeholder={I18n.t('Login.phone placeholder')}
          type="tel"
          value={values.phone}
          onChange={handleChange}
          onBlur={handleBlur}
          autoComplete="username phone"
        />
      </FormControl>
      <TextField
        style={{
          height: 0,
          overflow: 'hidden',
          padding: 0,
          margin: 0,
          display: 'block',
        }}
        type="password"
        autoComplete="current-password"
        ref={pass}
      />
      <FormControlLabel
        sx={inputSx}
        control={
          <Checkbox
            name="keepSessionOpen"
            checked={values.keepSessionOpen[0] === 'on'}
            onChange={handleChange}
            value="on"
            color="primary"
          />
        }
        label={
          <Typography
            sx={{
              color: 'text.primary',
            }}
          >
            {I18n.t('LoginConfirmation.Keep session open')}
          </Typography>
        }
      />
      <NextButton
        fullWidth
        variant="contained"
        type="submit"
        color="primary"
        disabled={isSubmitting}
      >
        {I18n.t('Login.next')}
      </NextButton>
    </form>
  );
}

LoginForm.propTypes = {
  actions: object.isRequired,
};

export default connector(LoginForm);
